export default __webpack_public_path__ + "fb15cbf3ec6a56ff987d247dbe9f5d46.png";